import { Filter, FilterRegistration } from '../types/filter';
import {
  andFilterPredicate,
  orFilterPredicate,
  trueFilterPredicate,
  falseFilterPredicate,
  isDefinedFilterPredicate,
  isNotDefinedFilterPredicate,
  isDefinedNotEmptyFilterPredicate,
  isNotDefinedOrEmptyFilterPredicate,
  equalFilterPredicate,
  notEqualFilterPredicate,
  greaterThanFilterPredicate,
  greaterThanOrEqualFilterPredicate,
  lessThanFilterPredicate,
  lessThanOrEqualFilterPredicate,
  startsWithFilterPredicate,
  endsWithFilterPredicate,
  likeFilterPredicate,
  notLikeFilterPredicate,
  regexFilterPredicate,
  containsTextFilterPredicate,
  inFilterPredicate,
  notInFilterPredicate
} from './filter.predicates';


// Logical Filters
export const andFilter = {
  operator: 'and',
  predicate: andFilterPredicate,
}
export const orFilter = {
  operator: 'or',
  predicate: orFilterPredicate
}

// Unary Filters
export const trueFilter = {
  operator: 'true',
  predicate: trueFilterPredicate
}
export const falseFilter = {
  operator: 'false',
  predicate: falseFilterPredicate
}
export const isDefinedFilter = {
  operator: 'isDefined',
  predicate: isDefinedFilterPredicate
}
export const isNotDefinedFilter = {
  operator: 'isNotDefined',
  predicate: isNotDefinedFilterPredicate
}
export const isDefinedNotEmptyFilter = {
  operator: 'isDefinedNotEmpty',
  predicate: isDefinedNotEmptyFilterPredicate
}
export const isNotDefinedOrEmptyFilter = {
  operator: 'isNotDefinedOrEmpty',
  predicate: isNotDefinedOrEmptyFilterPredicate
}

// Relational Filters
export const equalFilter = {
  operator: 'equal',
  predicate: equalFilterPredicate
}
export const notEqualFilter = {
  operator: 'notEqual',
  predicate: notEqualFilterPredicate
}
export const greaterThanFilter = {
  operator: 'greaterThan',
  predicate: greaterThanFilterPredicate
}
export const greaterThanOrEqualFilter = {
  operator: 'greaterThanOrEqual',
  predicate: greaterThanOrEqualFilterPredicate
}
export const lessThanFilter = {
  operator: 'lessThan',
  predicate: lessThanFilterPredicate
}
export const lessThanOrEqualFilter = {
  operator: 'lessThanOrEqual',
  predicate: lessThanOrEqualFilterPredicate
}

export const startsWithFilter = {
  operator: 'startsWith',
  predicate: startsWithFilterPredicate
}
export const endsWithFilter = {
  operator: 'endsWith',
  predicate: endsWithFilterPredicate
}
export const likeFilter = {
  operator: 'like',
  predicate: likeFilterPredicate
}
export const notLikeFilter = {
  operator: 'notLike',
  predicate: notLikeFilterPredicate
}
export const regexFilter = {
  operator: 'regex',
  predicate: regexFilterPredicate
}
export const containsTextFilter = {
  operator: 'containsText',
  predicate: containsTextFilterPredicate
}

export const inFilter = {
  operator: 'in',
  predicate: inFilterPredicate
}
export const notInFilter = {
  operator: 'notIn',
  predicate: notInFilterPredicate
}

export const filters: FilterRegistration<unknown, Filter>[] = [
  andFilter,
  orFilter,
  trueFilter,
  falseFilter,
  isDefinedFilter,
  isNotDefinedFilter,
  isDefinedNotEmptyFilter,
  isNotDefinedOrEmptyFilter,
  equalFilter,
  notEqualFilter,
  greaterThanFilter,
  greaterThanOrEqualFilter,
  lessThanFilter,
  lessThanOrEqualFilter,
  startsWithFilter,
  endsWithFilter,
  likeFilter,
  notLikeFilter,
  regexFilter,
  containsTextFilter,
  inFilter,
  notInFilter
]
